import { memo } from "react";
import Grid from "components/primitives/Grid";
import { tableCells } from "../GroupsTable.config";
import Tables from "components/Tables";

function GroupsTableControls() {
  return (
    <Grid container sx={{ alignItems: "center", minHeight: "64px", padding: "0 8px" }}>
      <Grid {...tableCells.name} size={{ xs: 6, lg: 3 }} sx={{ minWidth: 270, padding: "0 8px" }}>
        <Tables.Components.SearchTextInput />
      </Grid>
    </Grid>
  );
}

export default memo(GroupsTableControls);
